exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".contenedorTotal{padding:0;background-color:#f8f8ff}.borderF{border:1px solid red}.borderV{border:1px solid #fff}.car{border:1px solid transparent;border-color:#c4c4c4}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f9776d38","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/componentes/filtradoTraza.vue
// module id = 477
// module chunks = 0